import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { EmbeddedShell } from "./EmbeddedShell";
import { StandaloneShell } from "./StandaloneShell";
import { AppFooter, FooterVisibilityProvider } from "./AppFooter";
import { PublicShell } from "../features/public/PublicShell";
import { PublicEntry } from "../features/public/PublicEntry";
import { GuestJoin } from "../features/public/GuestJoin";
import { LEGACY_ENTRY_PATHS, rootNeedsCleanup } from "../features/public/publicFlow";

// Host-mode detection (modules/04 §3): an iframe inside a police system vs. standalone in a
// Citrix-published Chrome. Standalone routing:
//   /                    public phone/OTP call flow (minimal chrome, clean URL only)
//   /join                guest invitation link (#<token>)
//   retired entries      /station, /demo/traffic, /demo/ttraffic, /demo/field → clean "/"
//   /*                   meetings and admin console (StandaloneShell); launch pages render
//                        the officer call flow from their injected bootstrap
//
// Exactly one shell renders above the single shared footer; the footer hides itself while a
// live call screen is mounted. The viewport column is inlined (not only in styles.css) because
// the app-service launch page loads the JS bundle without the extracted CSS.
export function AppRoot() {
  const isEmbedded = window.self !== window.top;
  return (
    <FooterVisibilityProvider>
      <div className="vc-app" style={{ height: "100dvh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
          {isEmbedded ? <EmbeddedShell /> : (
            <Routes>
              <Route path="/" element={<PublicRoot />} />
              <Route path="/join" element={<PublicShell><GuestJoin /></PublicShell>} />
              {LEGACY_ENTRY_PATHS.map((path) => (
                <Route key={path} path={path} element={<Navigate to="/" replace />} />
              ))}
              <Route path="/*" element={<StandaloneShell />} />
            </Routes>
          )}
        </div>
        <AppFooter />
      </div>
    </FooterVisibilityProvider>
  );
}

function PublicRoot() {
  const { search, hash } = useLocation();
  // Drop legacy query/fragment (tokens, call ids) — the bare "/" then renders the OTP entry.
  if (rootNeedsCleanup(search, hash)) return <Navigate to="/" replace />;
  return <PublicShell><PublicEntry /></PublicShell>;
}
